import React, { useState } from "react";
import "./welcome.css";

// import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import logo from "../../images/PPKM_Head.png";
import { useNavigate } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";

const Welcome = () => {
  const navigate = useNavigate();

  return (
    <div className="welcome-page">
      <div className="welcome-container">
        <div className="welcome-wrapper">
          <div className="welcome-title">
            <img className="welcome-logo" src={logo} alt="Logo" />
          </div>
          {/* <p className="title_para">PPKM </p>
          <p className="title_para2">Malaysia Shopping Malls Association</p> */}
          <p className="welcome_title_para3">
            Welcome to PPKM Membership System
          </p>

          <form action="#">
            <label className="welcome-label col-md-12">
              Is this your first time login?
            </label>
            <div className="welcome-button">
              <div
                className="welcome-input-row2 button"
                onClick={() => navigate("/first_time_login")}
              >
                <input type="submit" value="Yes" />
              </div>
              <div
                className="welcome-input-row2 button"
                onClick={() => navigate("/login")}
              >
                <input type="submit" value="No" />
              </div>
              <div>
                <label className="never-show-check">
                  <input type="checkbox" />
                  Never show this again
                </label>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
